var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33358 6.03176L1.99343 0.691706C1.86992 0.568097 1.70504 0.5 1.52924 0.5C1.35343 0.5 1.18856 0.568097 1.06504 0.691706L0.671779 1.08487C0.415879 1.34107 0.415879 1.75745 0.671779 2.01326L5.15604 6.49751L0.666803 10.9867C0.543292 11.1104 0.475098 11.2751 0.475098 11.4508C0.475098 11.6267 0.543292 11.7915 0.666803 11.9152L1.06007 12.3083C1.18368 12.4319 1.34846 12.5 1.52426 12.5C1.70006 12.5 1.86494 12.4319 1.98845 12.3083L7.33358 6.96336C7.45738 6.83936 7.52538 6.6738 7.52499 6.49781C7.52538 6.32112 7.45738 6.15566 7.33358 6.03176Z",
    fill: "#6A6A6A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.7e647aa29ccf779e17c09034f409de69.svg";
export { ForwardRef as ReactComponent };